import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';

// const login=require('@/views/login').default
// 开发环境不使用懒加载, 因为懒加载页面太多的话会造成webpack热更新太慢, 所以只有生产环境使用懒加载
const _import = require('./import-' + process.env.NODE_ENV + ".js");
console.log('./import-' + process.env.NODE_ENV + ".js");


const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err);
};
Vue.use(VueRouter);
var menuList = [
  {
    'menuId': 1,
    'parentId': 0,
    'parentName': null,
    'name': '业务操作',
    'url': "/SupInvoiceList/SupInvoiceList",
    'perms': null,
    'type': 0,
    'icon': 'el-icon-notebook-1',
    'orderNum': 0,
    'open': null,
    'list': [{
      'menuId': 10,
      'parentId': 2,
      'parentName': null,
      'name': '待报价单',
      'url': '/SupInvoiceList/SupInvoiceList',
      'perms': null,
      'type': 0,
      'icon': 'el-icon-notebook-2',
      'orderNum': 1,
      'open': null,
      'list': null
    }, {
      'menuId': 14,
      'parentId': 1,
      'parentName': null,
      'name': '合同签订',
      'url': "/OnlineContractList/OnlineContractList",
      'perms': null,
      'type': 0,
      'icon': 'el-icon-s-platform',
      'orderNum': 0,
      'open': null,
      'list': null
    }, {
      'menuId': 13,
      'parentId': 1,
      'parentName': null,
      'name': '订单确认',
      'url': "/OrderConfirmList/OrderConfirmList",
      'perms': null,
      'type': 0,
      'icon': 'el-icon-notebook-1',
      'orderNum': 0,
      'open': null,
      'list': null
    }, {
      'menuId': 11,
      'parentId': 2,
      'parentName': null,
      'name': '送货制单',
      'url': '/Operation_SHOrder/Operation_SHOrder',
      'perms': null,
      'type': 0,
      'icon': 'el-icon-notebook-2',
      'orderNum': 1,
      'open': null,
      'list': null
    }, {
      'menuId': 12,
      'parentId': 2,
      'parentName': null,
      'name': '发票提报',
      'url': '/InvoiceNotice/InvoiceNotice',
      'perms': null,
      'type': 0,
      'icon': 'el-icon-notebook-2',
      'orderNum': 1,
      'open': null,
      'list': null
    }, {
      'menuId': 15,
      'parentId': 1,
      'parentName': null,
      'name': '季度对账单',
      'url': "/AccountStatementList/AccountStatementList",
      'perms': null,
      'type': 0,
      'icon': 'el-icon-s-platform',
      'orderNum': 0,
      'open': null,
      'list': null
    }, {
      'menuId': 16,
      'parentId': 1,
      'parentName': null,
      'name': '质量整改单',
      'url': "/RectificationList/RectificationList",
      'perms': null,
      'type': 0,
      'icon': 'el-icon-s-platform',
      'orderNum': 0,
      'open': null,
      'list': null
    }, {
      'menuId': 16,
      'parentId': 1,
      'parentName': null,
      'name': '库存填报',
      'url': "/FactorypricingList/FactorypricingList",
      'perms': null,
      'type': 0,
      'icon': 'el-icon-s-platform',
      'orderNum': 0,
      'open': null,
      'list': null
    }
      // ,{
      //   'menuId':17,
      //   'parentId': 1,
      //   'parentName': null,
      //   'name': '招标应标',
      //   'url': "/Invitation/Invitation",
      //   'perms': null,
      //   'type': 0,
      //   'icon': 'el-icon-s-platform',
      //   'orderNum': 0,
      //   'open': null,
      //   'list':null
      // }
    ]
  },
  {
    'menuId': 2,
    'parentId': 0,
    'parentName': null,
    'name': '报表中心',
    'url': '/BuyInvoiceList/BuyInvoiceList',
    'perms': null,
    'type': 0,
    'icon': 'el-icon-notebook-2',
    'orderNum': 1,
    'open': null,
    'list': [{
      'menuId': 21,
      'parentId': 2,
      'parentName': null,
      'name': '订单执行',
      'url': '/BuyInvoiceList/BuyInvoiceList',
      'perms': null,
      'type': 0,
      'icon': 'el-icon-notebook-2',
      'orderNum': 1,
      'open': null,
      'list': null
    }, {
      'menuId': 22,
      'parentId': 2,
      'parentName': null,
      'name': '收货查询',
      'url': '/ContactUpload/ContactUpload',
      'perms': null,
      'type': 0,
      'icon': 'el-icon-notebook-2',
      'orderNum': 1,
      'open': null,
      'list': null
    }
      // ,{
      //   'menuId': 24,
      //   'parentId': 2,
      //   'parentName': null,
      //   'name': '等待报价',
      //   'url': '/ReportPrice/ReportPrice',
      //   'perms': null,
      //   'type': 0,
      //   'icon': 'el-icon-notebook-2',
      //   'orderNum':1,
      //   'open': null,
      //   'list': null
      // }
      , {
      'menuId': 25,
      'parentId': 2,
      'parentName': null,
      'name': '到货拒收',
      'url': '/ArrivalRejection/ArrivalRejection',
      'perms': null,
      'type': 0,
      'icon': 'el-icon-notebook-2',
      'orderNum': 1,
      'open': null,
      'list': null
    }, {
      'menuId': 26,
      'parentId': 2,
      'parentName': null,
      'name': '待开发票',
      'url': '/BeInvoiceList/BeInvoiceList',
      'perms': null,
      'type': 0,
      'icon': 'el-icon-notebook-2',
      'orderNum': 1,
      'open': null,
      'list': null
    }, {
      'menuId': 27,
      'parentId': 2,
      'parentName': null,
      'name': '寄售库存查询',
      'url': '/Inventory/Inventory',
      'perms': null,
      'type': 0,
      'icon': 'el-icon-notebook-2',
      'orderNum': 1,
      'open': null,
      'list': null
    }, {
      'menuId': 28,
      'parentId': 2,
      'parentName': null,
      'name': '违规记录',
      'url': '/ViolationrecordList/ViolationrecordList',
      'perms': null,
      'type': 0,
      'icon': 'el-icon-notebook-2',
      'orderNum': 1,
      'open': null,
      'list': null
    }
    ]
  },
  // {
  //   'menuId':4,
  //   'parentId': 0,
  //   'parentName': null,
  //   'name': '质检信息',
  //   'url': '/QualityTestingList/QualityTestingList',
  //   'perms': null,
  //   'type': 0,
  //   'icon': 'el-icon-school',
  //   'orderNum': 2,
  //   'open': null,
  //   'list': [
  //     {
  //       'menuId': 41,
  //       'parentId': 3,
  //       'parentName': null,
  //       'name': '感官确认',
  //       'url': '/QualityTestingGGList/QualityTestingGGList',
  //       'perms': null,
  //       'type': 0,
  //       'icon': 'el-icon-notebook-2',
  //       'orderNum':1,
  //       'open': null,
  //       'list': null
  //     },{
  //       'menuId': 42,
  //       'parentId': 3,
  //       'parentName': null,
  //       'name': '初检确认',
  //       'url': '/QualityTestingCJList/QualityTestingCJList',
  //       'perms': null,
  //       'type': 0,
  //       'icon': 'el-icon-notebook-2',
  //       'orderNum':1,
  //       'open': null,
  //       'list': null
  //     },{
  //       'menuId': 43,
  //       'parentId': 3,
  //       'parentName': null,
  //       'name': '终检确认',
  //       'url': '/QualityTestingZJList/QualityTestingZJList',
  //       'perms': null,
  //       'type': 0,
  //       'icon': 'el-icon-notebook-2',
  //       'orderNum':1,
  //       'open': null,
  //       'list': null
  //     },{
  //       'menuId': 44,
  //       'parentId': 3,
  //       'parentName': null,
  //       'name': '质检记录',
  //       'url': '/QualityTestingList/QualityTestingList',
  //       'perms': null,
  //       'type': 0,
  //       'icon': 'el-icon-notebook-2',
  //       'orderNum':1,
  //       'open': null,
  //       'list': null
  //     },
  //   ]
  // },
  {
    'menuId': 3,
    'parentId': 0,
    'parentName': null,
    'name': '通知中心',
    'url': '/ToDoList/ToDoList',
    'perms': null,
    'type': 0,
    'icon': 'el-icon-school',
    'orderNum': 2,
    'open': null,
    'list': [{
      'menuId': 31,
      'parentId': 3,
      'parentName': null,
      'name': '待办事项',
      'url': '/ToDoList/ToDoList',
      'perms': null,
      'type': 0,
      'icon': 'el-icon-notebook-2',
      'orderNum': 1,
      'open': null,
      'list': null
    }, {
      'menuId': 32,
      'parentId': 3,
      'parentName': null,
      'name': '通知公告',
      'url': '/NoticeNotice/NoticeNotice',
      'perms': null,
      'type': 0,
      'icon': 'el-icon-box',
      'orderNum': 1,
      'open': null,
      'list': null
      },
      // {
      //   'menuId': 32,
      //   'parentId': 3,
      //   'parentName': null,
      //   'name': '预付款申请单',
      //   'url': '/advancepayment/advancepayment',
      //   'perms': null,
      //   'type': 0,
      //   'icon': 'el-icon-box',
      //   'orderNum': 1,
      //   'open': null,
      //   'list': null
      //   }
    ]
  }

];
// var menuList=JSON.parse(JSON.stringify(navDataList))
const globalRoutes = [
  { path: '/', redirect: '/login' },
  // { path: '/404',  component: () => import(/* webpackChunkName: "about" */ '../components/common/404.vue'), name: '404', meta: { title: '404未找到' } },
  { path: '/login', component: () => import(/* webpackChunkName: "login" */ '../views/login.vue'), name: 'login', meta: { title: '登录' } },
  { path: '/dlxxregister', component: () => import(/* webpackChunkName: "dlxxregister" */ '../views/reiger/dlxxregister.vue'), name: 'dlxxregister', meta: { title: '注册协议' } },
  { path: '/useregister', component: () => import(/* webpackChunkName: "useregister" */ '../views/reiger/useregister.vue'), name: 'useregister', meta: { title: '供货商信息' } },
  { path: '/SupplyObject', component: () => import(/* webpackChunkName: "SupplyObject" */ '../views/reiger/SupplyObject.vue'), name: 'SupplyObject', meta: { title: '供货对象信息' } },
  { path: '/Qualification', component: () => import(/* webpackChunkName: "Qualification" */ '../views/reiger/Qualification.vue'), name: 'Qualification', meta: { title: '上传资质文件' } },
  { path: '/dlxxEnd', component: () => import(/* webpackChunkName: "dlxxEnd" */ '../views/reiger/dlxxEnd.vue'), name: 'dlxxEnd', meta: { title: '注册完成' } },

  { path: '/UserCenterinfoNot', component: () => import(/* webpackChunkName: "UserCenterinfoNot" */ '../views/inform/UserCenterinfoNot.vue'), name: 'UserCenterinfoNot', meta: { title: '修改供货商信息' } },
  { path: '/UserCenterWareinfo', component: () => import(/* webpackChunkName: "UserCenterWareinfo" */ '../views/inform/UserCenterWareinfo.vue'), name: 'UserCenterWareinfo', meta: { title: '修改供货对象信息' } },
  { path: '/UserCenterWareEnd', component: () => import(/* webpackChunkName: "UserCenterWareEnd" */ '../views/inform/UserCenterWareEnd.vue'), name: 'UserCenterWareEnd', meta: { title: '修改上传资质文件' } },
  { path: '/pricingconfirmation', component: () => import(/* webpackChunkName: "pricingconfirmation" */ '../views/pricing/pricingconfirmation.vue'), name: 'pricingconfirmation', meta: { title: '定价订单' } },
  { path: '/pricinglist', component: () => import(/* webpackChunkName: "pricinglist" */ '../views/pricing/pricinglist.vue'), name: 'pricinglist', meta: { title: '定价订单' } },
  { path: '/materiallist', component: () => import(/* webpackChunkName: "materiallist" */ '../views/material/materiallist.vue'), name: 'materiallist', meta: { title: '物料报表' } },
  { path: '/materialconfirmation', component: () => import(/* webpackChunkName: "materialconfirmation" */ '../views/material/materialconfirmation.vue'), name: 'materialconfirmation', meta: { title: '物料报表' } },
  { path: '/opentrenderslist', component: () => import(/* webpackChunkName: "opentrenders" */ '../views/opentrenders/opentrenderslist.vue'), name: 'opentrenderslist', meta: { title: '开标' } },
  { path: '/toubiaoinform', component: () => import(/* webpackChunkName: "opentrenders" */ '../views/opentrenders/toubiaoinform.vue'), name: 'toubiaoinform', meta: { title: '招投标' } },
  { path: '/xunbijiasinform', component: () => import(/* webpackChunkName: "opentrenders" */ '../views/opentrenders/xunbijiasinform.vue'), name: 'xunbijiasinform', meta: { title: '询价比' } },
  { path: '/viscreen', component: () => import(/* webpackChunkName: "viscreen" */ '../views/Visualscreen/viscreen.vue'), name: 'viscreen', meta: { title: '物料价格表分析' } },
  { path: '/advancepayment', component: () => import(/* webpackChunkName: "advancepayment" */ '../views/modules/advancepayment/advancepayment.vue'), name: 'advancepayment', meta: { title: '预付款申请单' } },
  { path: '/Corporatepayment', component: () => import(/* webpackChunkName: "Corporatepayment" */ '../views/modules/Corporatepayment/Corporatepayment.vue'), name: 'Corporatepayment', meta: { title: '预付款申请单' } },
  { path: '/Prepaymentverification', component: () => import(/* webpackChunkName: "Prepaymentverification" */ '../views/modules/Prepaymentverification/Prepaymentverification.vue'), name: 'Prepaymentverification', meta: { title: '预付款申请单' } },


  {
    path: '/OperationManual',
    component: () => import(/* webpackChunkName: "[request]" */ '../views/mainwarp.vue'),
    name: 'mainwarp',
    redirect: { name: 'mainwarp' },
    meta: { title: '新窗口打开的全局入口' },
    children: [
      { path: '/OperationManual', component: () => import(/* webpackChunkName: "OperationManual" */ '../views/homecharts/OperationManual.vue'), name: 'OperationManual', meta: { title: '操作手册' } },
      { path: '/CommonProblem', component: () => import(/* webpackChunkName: "CommonProblem" */ '../views/homecharts/CommonProblem.vue'), name: 'CommonProblem', meta: { title: '操作手册' } },
    ]
  },
  {
    path: '/Operationadd',
    component: () => import(/* webpackChunkName: "[request]" */ '../views/mainadd.vue'),
    name: 'mainadd',
    redirect: { name: 'main' },
    meta: { title: '新窗口打开的全局入口' },
    children: [
      { path: '/Operationadd', component: () => import(/* webpackChunkName: "Operationadd" */ '../views/modules/Operation_SHOrder/Operation/Operation_SHOrder.vue'), name: 'Operationadd', meta: { title: '送货单制作' } },
      { path: '/SupInvoiceadd', component: () => import(/* webpackChunkName: "SupInvoiceadd" */ '../views/modules/SupInvoiceList/SupInvoice/SupInvoiceadd.vue'), name: 'SupInvoiceadd', meta: { title: '报价单修改' } },
      { path: '/SupInvoiceaddcom', component: () => import(/* webpackChunkName: "SupInvoiceaddcom" */ '../views/modules/SupInvoiceList/SupInvoice/SupInvoiceaddcom.vue'), name: 'SupInvoiceaddcom', meta: { title: '报价单修改' } },
      { path: '/SupInvoiceaddcont', component: () => import(/* webpackChunkName: "SupInvoiceaddcont" */ '../views/modules/SupInvoiceList/SupInvoice/SupInvoiceaddcont.vue'), name: 'SupInvoiceaddcont', meta: { title: '报价单修改' } },
      { path: '/SupInvoiceaddFB', component: () => import(/* webpackChunkName: "SupInvoiceaddcont" */ '../views/modules/SupInvoiceList/SupInvoice/SupInvoiceaddFB.vue'), name: 'SupInvoiceaddFB', meta: { title: '报价单修改' } },
      { path: '/OrderConfirm', component: () => import(/* webpackChunkName: "OrderConfirm" */ '../views/modules/OrderConfirmList/OrderConfirm/OrderConfirm.vue'), name: 'OrderConfirm', meta: { title: '定价确认' } },
      { path: '/InvoiceNoticeadd', component: () => import(/* webpackChunkName: "InvoiceNoticeadd" */ '../views/modules/InvoiceNotice/InvoiceNotice/InvoiceNotice.vue'), name: 'InvoiceNoticeadd', meta: { title: '发票录入' } },
      { path: '/OnlineContract', component: () => import(/* webpackChunkName: "OnlineContract" */ '../views/modules/OnlineContractList/OnlineContract/OnlineContract.vue'), name: 'OnlineContract', meta: { title: '在线合同' } },
      { path: '/AccountStatement', component: () => import(/* webpackChunkName: "OnlineContract" */ '../views/modules/AccountStatementList/AccountStatement/AccountStatement.vue'), name: 'AccountStatement', meta: { title: '对账单' } },
      { path: '/Rectification', component: () => import(/* webpackChunkName: "Rectification" */ '../views/modules/RectificationList/Rectification/Rectification.vue'), name: 'Rectification', meta: { title: '整改单' } },
      { path: '/Invitationedit', component: () => import(/* webpackChunkName: "Invitationedit" */ '../views/modules/Invitation/invitation/Invitationedit.vue'), name: 'Invitationedit', meta: { title: '招标应标' } },
      { path: '/QualityTesting', component: () => import(/* webpackChunkName: "Invitationedit" */ '../views/modules/QualityTestingList/QualityTesting/QualityTesting.vue'), name: 'QualityTesting', meta: { title: '质检记录' } },
      { path: '/QualityTestingCJ', component: () => import(/* webpackChunkName: "Invitationedit" */ '../views/modules/QualityTestingCJList/QualityTestingCJ/QualityTestingCJ.vue'), name: 'QualityTestingCJ', meta: { title: '初检确认' } },
      { path: '/QualityTestingZJ', component: () => import(/* webpackChunkName: "Invitationedit" */ '../views/modules/QualityTestingZJList/QualityTestingZJ/QualityTestingZJ.vue'), name: 'QualityTestingZJ', meta: { title: '终检确认' } },
      { path: '/QualityTestingGG', component: () => import(/* webpackChunkName: "Invitationedit" */ '../views/modules/QualityTestingGGList/QualityTestingGG/QualityTestingGG.vue'), name: 'QualityTestingGG', meta: { title: '感官确认' } },
      { path: '/Factorypricing', component: () => import(/* webpackChunkName: "Factorypricing" */ '../views/modules/FactorypricingList/Factorypricing/Factorypricing.vue'), name: 'Factorypricing', meta: { title: '收集填报' } },
    ]
  }
];


// 主入口路由(需嵌套上左右整体布局)
const mainRoutes = {
  path: '/home',
  component: () => import(/* webpackChunkName: "[request]" */ '../views/main.vue'),
  name: 'main',
  redirect: { name: 'home' },
  meta: { title: '主入口整体布局' },
  children: [
    // 通过meta对象设置路由展示方式
    // 1. isTab: 是否通过tab展示内容, true: 是, false: 否
    // 2. iframeUrl: 是否通过iframe嵌套展示内容, '以http[s]://开头': 是, '': 否
    // 提示: 如需要通过iframe嵌套展示内容, 但不通过tab打开, 请自行创建组件使用iframe处理!


    { path: '/home', component: Home, name: 'home', meta: { title: '首页', isTab: true } },
    { path: '/404', component: () => import(/* webpackChunkName: "404" */ '../components/common/404.vue'), name: '404', meta: { title: '404未找到' } },
    // { path: '/output/output', component: _import('modules/output/output'), name: 'output', meta: { title: '产值' } }
  ],
  // beforeEnter (to, from, next) {
  //   let token =  window.localStorage.getItem('token')
  //   if (to.path === '/login') {
  //     window.localStorage.removeItem('token');
  //     return next();
  //   }
  //   if (!token&& to.path != '/login' ) {   
  //     next({
  //       path: '/login'
  //     });
  //   }
  //   else
  //   next()
  // }
};
const router = new VueRouter({
  mode: 'hash',
  scrollBehavior: () => ({ y: 0 }),
  isAddDynamicMenuRoutes: false, // 是否已经添加动态(菜单)路由
  routes: globalRoutes.concat(mainRoutes)
});


router.beforeEach((to, from, next) => {

  let token = window.localStorage.getItem('token');
  if (!token && to.path != '/login' && to.path != "/dlxxregister" && to.path != "/useregister" && to.path != "/SupplyObject" && to.path != "/viscreen"
    && to.path != "/Qualification" && to.path != "/pricinglist" && to.path != "/materiallist" && to.path != "/materialconfirmation" && to.path != "/dlxxEnd" && to.path != "/pricingconfirmation"
    && to.path != "/404" && to.path != "/opentrenderslist"&& to.path != "/advancepayment"&& to.path != "/Corporatepayment"&& to.path != "/Prepaymentverification") {   //如果获取不到user说明登录失效了
    next({
      path: '/login'
      // query: { redirect: to.fullPath } // 将跳转的路由path作为参数，登录成功后跳转到该路由-xlz
    });
  }
  // 添加动态(菜单)路由
  // 1. 已经添加 or 全局路由, 直接访问
  // 2. 获取菜单列表, 添加并保存本地存储
  if (router.options.isAddDynamicMenuRoutes || fnCurrentRouteType(to, globalRoutes) === 'global') {
    next();
  } else {
    fnAddDynamicMenuRoutes(menuList);
    router.options.isAddDynamicMenuRoutes = true;
    sessionStorage.setItem('menuList', JSON.stringify(menuList || '[]'));
    next({ ...to, replace: true });
  }
});

/**
 * 判断当前路由类型, global: 全局路由, main: 主入口路由
 * @param {*} route 当前路由
 */
function fnCurrentRouteType (route, globalRoutes = []) {
  var temp = [];
  for (var i = 0; i < globalRoutes.length; i++) {
    if (route.path === globalRoutes[i].path) {
      return 'global';
    } else if (globalRoutes[i].children && globalRoutes[i].children.length >= 1) {
      temp = temp.concat(globalRoutes[i].children);
    }
  }
  return temp.length >= 1 ? fnCurrentRouteType(route, temp) : 'main';
}
function fnAddDynamicMenuRoutes (menuList = [], routes = []) {

  for (var i = 0; i < menuList.length; i++) {
    var route = {
      path: menuList[i].url,
      component: _import(`modules${menuList[i].url}`),
      name: menuList[i].url,
      meta: {
        menuId: menuList[i].menuId,
        title: menuList[i].name,
        isDynamic: true,
        isTab: true,
        iframeUrl: ''
      }
    };

    if (menuList[i].list != null && menuList[i].list.length != 0) {
      for (var a = 0; a < menuList[i].list.length; a++) {
        var route = {
          path: menuList[i].list[a].url,
          component: _import(`modules${menuList[i].list[a].url}`),
          name: menuList[i].list[a].url,

          meta: {
            menuId: menuList[i].list[a].menuId,
            title: menuList[i].list[a].name,
            isDynamic: true,
            isTab: true,
            iframeUrl: ''
          }
        };
        if (menuList[i].list[a].list != null && menuList[i].list[a].list.length != 0) {
          for (var b = 0; b < menuList[i].list[a].list.length; a++) {
            var route = {
              path: menuList[i].list[a].list[b].url,
              component: _import(`modules${menuList[i].list[a].list[b].url}`),
              name: menuList[i].list[a].list[b].url,
              meta: {
                menuId: menuList[i].list[a].list[b].menuId,
                title: menuList[i].list[a].list[b].name,
                isDynamic: true,
                isTab: true,
                iframeUrl: ''
              }
            };
            routes.push(route);
          }
        }
        routes.push(route);
      }
    }

    routes.push(route);
  }


  mainRoutes.name = 'main-dynamic';
  mainRoutes.children = routes;

  router.addRoutes([
    mainRoutes,
    { path: '*', redirect: { name: '404' } }
  ]);
  sessionStorage.setItem('dynamicMenuRoutes', JSON.stringify(mainRoutes.children || '[]'));
  console.log(router);

}

export default router;